import { memo } from 'react'
import { Handle, Position, type NodeProps } from '@xyflow/react'

interface MindMapConceptNodeData {
  conceptId: string
  label: string
  category: string
  categoryColor: string
  importance: string
  description: string
  section: string
  dimmed: boolean
  [key: string]: unknown
}

function MindMapConceptNodeComponent({ data }: NodeProps) {
  const d = data as MindMapConceptNodeData

  return (
    <>
      <Handle type="target" position={Position.Left} className="!w-0 !h-0 !border-0 !bg-transparent" />
      <div
        className={`px-2.5 py-1.5 rounded-full border cursor-pointer transition-all select-none
          ${d.dimmed ? 'opacity-20' : 'opacity-100'}
        `}
        style={{
          borderColor: d.categoryColor,
          backgroundColor: `${d.categoryColor}10`,
        }}
      >
        <div className="flex items-center gap-1.5">
          <div
            className="w-2 h-2 rounded-full flex-shrink-0"
            style={{ backgroundColor: d.categoryColor }}
          />
          <span
            className="text-xs font-medium truncate max-w-[120px]"
            style={{ color: d.categoryColor }}
          >
            {d.label}
          </span>
          {d.importance === 'core' && (
            <span className="text-[8px] font-bold uppercase text-amber-500">core</span>
          )}
        </div>
      </div>
      <Handle type="source" position={Position.Right} className="!w-0 !h-0 !border-0 !bg-transparent" />
    </>
  )
}

export const MindMapConceptNode = memo(MindMapConceptNodeComponent)
